import {
  USERS_LOADING,
  USERS_SET_DATA,
  USERS_ERROR,
  USERS_REMOVE_DATA,
  ADD_CHATED_USER_START,
  ADD_CHATED_USER_SUCCESS,
  ADD_CHATED_USER_ERROR,
  LIST_CHATED_USER_ERROR,
  LIST_CHATED_USER_SUCCESS,
  LIST_CHATED_USER_START,
  CHAT_FETCH_START,
  CHAT_FETCH_SUCCESS,
  CHAT_FETCH_ERROR,
  REAL_TIME_CHAT
} from "./constants";
const initialState = {
  loading: false,
  loadedUser: false,
  errorMessage: {},
  users: [],
  chatedUser: [],
  allChats: []
};

export function userReducer(state = initialState, action) {
  switch (action.type) {
    case USERS_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case USERS_ERROR:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case USERS_SET_DATA:
      return {
        ...state,
        users: action.payload,
      };
    case USERS_REMOVE_DATA:
      return {
        ...state,
        users: state.users.filter((user) => user.id !== action.payload),
      };
    case ADD_CHATED_USER_START:
    case LIST_CHATED_USER_START:
      return {
        ...state,
        loadedUser: false,
        loading: true,
      };
    case ADD_CHATED_USER_SUCCESS:
    case LIST_CHATED_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        loadedUser: true,
        chatedUser: action.payload,
      };
    case ADD_CHATED_USER_ERROR:
    case LIST_CHATED_USER_ERROR:
      return {
        ...state,
        loading: false,
        loadedUser: false,
        errorMessage: action.payload
      };
    case CHAT_FETCH_START:
      return {
        ...state,
        loading: true,
      };
    case CHAT_FETCH_SUCCESS:
      if(action.payload.length){
        action.payload.sort(function(x, y){
          return new Date(x.updated_on) - new Date(y.updated_on);
        })
      }
      return {
        ...state,
        loading: false,
        allChats: action.payload,
      };
    case CHAT_FETCH_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload,
      };
    case REAL_TIME_CHAT:
      return {
        ...state,
        allChats: [...state.allChats, action.payload]
      };
    default:
      return state;
  }
}
